const desktopSteps = [
  { target: ".cpc-thinking-container", title: "Thinking Mode", content: "Enable Extended Thinking to let Genie reason through complex problems step by step before responding." },
].map(step => ({ ...step, placement: step.placement || "bottom" }));
 
const mobileSteps = [
  { target: ".cpc-thinking-container", title: "Thinking Mode", content: "Enable Extended Thinking to let Genie reason through complex problems step by step before responding." },
].map(step => ({ ...step, placement: step.placement || "bottom" }));
export { desktopSteps, mobileSteps };